import React from 'react'
import { Button } from 'reactstrap'
import { MapContainer as Map, Marker, Popup, TileLayer } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import './mapa.css'

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: null,
    iconSize: [20, 32],
    iconAnchor: [10, 32]
});

L.Marker.prototype.options.icon = DefaultIcon;

//const lat = -32.3120685
//const lon = -58.070329
//const lat = -32.312120
//const lon = -58.069985

class Mapa extends React.Component {
    constructor() {
        super()
        this.state = {
            lat: -32.312120,
            lng: -58.069970,
            zoom: 17
        }
        this.comoLlegarPopup = this.comoLlegarPopup.bind(this);
    }

    comoLlegarPopup() {
        const _this = this
        if ((navigator.platform.indexOf("iPhone") != -1)
            || (navigator.platform.indexOf("iPod") != -1)
            || (navigator.platform.indexOf("iPad") != -1))
            window.open(`maps://maps.google.com/maps?daddr=${_this.state.lat},${_this.state.lng}&amp;ll=`);
        else
            window.open(`http://maps.google.com/maps?daddr=${_this.state.lat},${_this.state.lng}&amp;ll=`);
    }

    render() {
        const position = [this.state.lat, this.state.lng];
        return (
            <Map center={position} zoom={this.state.zoom} maxZoom={20} className="mapaEmpresa" >
                <TileLayer url={'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'} />
                <Marker
                    position={position}
                >
                    <Popup>
                        <Button outline color="info" onClick={this.comoLlegarPopup} >¿Cómo llegar?</Button>
                    </Popup>
                </Marker>
            </Map>
        );
    }
}

export default Mapa;